import React from "react";

const ScanConsentIllustration = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <circle cx="100" cy="50" r="38" fill="#FEF2F2" />
    <path
      d="M100 30C88.954 30 80 38.954 80 50V58H120V50C120 38.954 111.046 30 100 30Z"
      fill="#FEE2E2"
      stroke="#C73732"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M92 58H108V64C108 67.314 105.314 70 102 70H98C94.686 70 92 67.314 92 64V58Z"
      fill="#C73732"
    />
    <path
      d="M100 62V54M96 58H104"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="142" cy="38" r="16" fill="#ECFDF5" stroke="#86EFAC" strokeWidth="1.5" />
    <path
      d="M142 32V44M136 38H148"
      stroke="#16A34A"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M58 62L52 76L64 76Z"
      fill="#C73732"
      stroke="#C73732"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <circle cx="58" cy="58" r="10" fill="#FEE2E2" stroke="#C73732" strokeWidth="2" />
    <path
      d="M44 78C50 72 66 72 72 78"
      stroke="#CBD5E1"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default ScanConsentIllustration;
